import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import { ToggleField, Modal, SidePanelActions } from 'cx-ui-components';
import styled from 'styled-components';
import FieldWrapper from 'cx-ui-components/src/components/ConfigUi/Field/FieldWrapper';
import messages from "./messages";
import { FormattedMessage } from 'react-intl';

const PopupTitle = styled.div`
  font-size: 16px;
  margin-bottom: 40px;
  text-align: center;
`;

const CheckboxLabel = styled.div`
  margin: 0px 10px 20px 10px;
  display: flex;
  font-size: 13px;
  line-height: 1.5em;
`;

const CheckboxText = styled.div`
  margin: 0px;
  font-size: 13px;
  line-height: 1.5em;
`;

const Checkbox = styled.input`
  margin-right: 10px;
  margin-top: 4px;
  transform: scale(1.2);
`;

const EndText = styled.div`
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const StyledSidePanelActions = styled(SidePanelActions)`
  /* display: flex; */
  /* justify-content: center; */
`;

const LabeledCheckbox = ({ name, children, required }) => (
  <Field
    name={name}
    type="checkbox"
    labelChildren={children}
    normalize={(value) => value === true}
    component={({ labelChildren, input }) => (
      <CheckboxLabel>
        <Checkbox {...input} type="checkbox" required={required} />
        <CheckboxText>{labelChildren}</CheckboxText>
      </CheckboxLabel>
    )}
    required={required}
  />
);

const getTitleText = (newArtifact, oldArtifact) => {
  const termPolicyText1 = () =>
    < FormattedMessage
      {...messages.termPolicyText1}
      values={{
        b: <b>{messages.termPolicyText1.b}</b>,
        i: <i>{messages.termPolicyText1.i}</i>
      }}
    />

  const termPolicyText2 = () =>
    < FormattedMessage
      {...messages.termPolicyText2}
      values={{
        b: <b>{messages.termPolicyText2.b}</b>
      }}
    />

  const termPolicyText3 = () =>
    < FormattedMessage
      {...messages.termPolicyText3}
      values={{
        b: <b>{messages.termPolicyText3.b}</b>
      }}
    />

  const termPolicyText4 = () =>
    < FormattedMessage
      {...messages.termPolicyText4}
      values={{
        b: <b>{messages.termPolicyText4.b}</b>
      }}
    />

  const endPolicy = () =>
    < FormattedMessage
      {...messages.endPolicy}
    />

  switch (newArtifact.get('submitSource')) {
    case 'createPolicy':
      let createText = 'This will create new version.'
      return [createText, termPolicyText1, termPolicyText2, termPolicyText3, termPolicyText4, endPolicy];
    case 'createVersion':
      let createVersionText = 'This will create new version';
      return [createVersionText, termPolicyText1, termPolicyText2, termPolicyText3, termPolicyText4, endPolicy];
    case 'changeVersion':
      let changeVersionText = "Changing the Artifact Lifecycle Policy's active version."; 
     /* from " +
        oldArtifact.get('name') +
        ' to ' +
        newArtifact.get('name') +
        '.';*/
      const endChangeVersionPolicy = () =>
        < FormattedMessage
          {...messages.endChangeVersionPolicy}
        />
      return [changeVersionText, termPolicyText1, termPolicyText2, termPolicyText3, termPolicyText4, endChangeVersionPolicy];
    case 'enablePolicy':
      let enableText = 'This will enable this ' + oldArtifact.get('name');
      if (newArtifact.get('artifactSubtype')) {
        enableText += ' ' + newArtifact.get('artifactSubtype');
      }
      enableText += ' Artifacts Lifecycle Policy';
      if (oldArtifact && !oldArtifact.isEmpty()) {
        enableText += ' and disable the existing Policy of the same type and subtype.';
      }
      enableText += '.';

      return [enableText, termPolicyText1, termPolicyText2, termPolicyText3, termPolicyText4, endPolicy];
    case 'disablePolicy':
    default:
      let disableText = 'This will disable this ' + oldArtifact.get('name');
      if (newArtifact.get('artifactSubtype')) {
        disableText += ' ' + newArtifact.get('artifactSubtype');
      }
      disableText += ' Artifacts Lifecycle Policy.';
      const termDisablePolicy1 = () =>
        < FormattedMessage
          {...messages.termDisablePolicy1}
        />

      const termDisablePolicy2 = () =>
        < FormattedMessage
          {...messages.termDisablePolicy2}
          values={{
            b: <b>{messages.termDisablePolicy2.b}</b>,
            i: <i>{messages.termDisablePolicy2.i}</i>
          }}
        />

      const termDisbalePolicy3 = () =>
        < FormattedMessage
          {...messages.termDisbalePolicy3}
          values={{
            b: <b>{messages.termDisbalePolicy3.b}</b>,
            i: <i>{messages.termDisbalePolicy3.i}</i>
          }}
        />

      const termDisablePolicy4 = () =>
        // < FormattedMessage
        //   {...messages.termDisablePolicy4}
        //   values={{
        //     b: <b>{messages.termDisablePolicy4.b}</b>
        //   }}
        // />
        < FormattedMessage
          {...messages.termPolicyText4}
          values={{
            b: <b>{messages.termPolicyText4.b}</b>
          }}
        />

      const endDisablePolicyText = () =>
        < FormattedMessage
          {...messages.endDisablePolicyText}
        />
      return [disableText, termDisablePolicy1, termDisablePolicy2, termDisbalePolicy3, termDisablePolicy4, endDisablePolicyText];
  }
};

export default function TermsForm({ newArtifact, oldArtifact, handleSubmit, setTermsForm, invalid, key }) {
  const [title, titleText1, titleText2, titleText3, titleText4, titleText5] = getTitleText(newArtifact, oldArtifact);
  return (
    <form onSubmit={handleSubmit} key={key}>
      <PopupTitle>{title}</PopupTitle>
      <LabeledCheckbox name="storageLimitCosts" required>
        {titleText1()}
      </LabeledCheckbox>

      { newArtifact.get('submitSource') =="disablePolicy" &&
       <LabeledCheckbox name="billingPerGB" required>
        {titleText2()}
      </LabeledCheckbox>
}
     {/*} <LabeledCheckbox name="retrieveFromStorage" required>
        {titleText3()}
      </LabeledCheckbox> */}
     
      {((newArtifact.get('activeAction') && newArtifact.get('activeAction').toLowerCase() === 'delete') ||
        (oldArtifact.get('activeAction') && oldArtifact.get('activeAction').toLowerCase() === 'delete')) &&
        (
          <LabeledCheckbox name="deletedArtifacts" required>
            {titleText4()}
          </LabeledCheckbox>
        )}
      <EndText>{titleText5()}</EndText>
      <StyledSidePanelActions onCancel={() => setTermsForm(false)} invalid={invalid} />
    </form>
  );
}
